module.exports = __webpack_public_path__ + "img/8_life-skills.f13a5791.png";